<template>
<div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
    <span>
      <w-header-search-button @click="onClickSetSearchToolVisible"></w-header-search-button>
    </span>
  </el-row>
  <el-table-wrapper v-loading="isLoading" :data="tableData" :columns="sessionColumns" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool">
    <template slot-scope="scope" slot="sql-slot">
      <i class="far fa-search-plus c-pointer" @click="showSqlDetailPopup(scope.row)"></i>
    </template>
  </el-table-wrapper>
  <w-dbsession-sql-query-show-popup ref="sqlDetailPopup" />
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import floor from 'lodash/floor';
import cloneDeep from 'lodash/cloneDeep';
import { convertValuByUnit } from '@/utils/number';
import { analysisTimeType } from '@/constants/performance';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WDbsessionSqlQueryShowPopup from '../../../popup/DbsessionSqlQueryShowPopup';

export default {
  name: 'WDbSessionMssqlTable',
  mixins: [AnalysisTableMixin],
  components: {
    WDbsessionSqlQueryShowPopup,
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      isLoading: false,
      checkDatetime: null,
      columnDefault,
      tableData: [],
      showSearchTool: false,
      columns: [
        { prop: 'SID', label: '세션ID', sortable: true, searchable: true, width: 80, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'LOGIN_NAME', label: '사용자', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'HOST_NAME', label: '호스트명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'CLIENT_NET_ADDRESS', label: 'IP', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'DB_NAME', label: 'DB명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'PROGRAM_NAME', label: '프로그램명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'STATUS', label: '세션상태', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'CPU_TIME', label: 'CPU 누적 시간', sortable: true, formatter: this.cputimeConvert },
        { prop: 'MEMORY_USAGE', label: '메모리 사용량', sortable: true, formatter: this.convertValue },
        { prop: 'READS', label: '읽기 수', sortable: true, width: 70, formatter: this.convertValue },
        { prop: 'WRITES', label: '쓰기 수', sortable: true, width: 70, formatter: this.convertValue },
        { prop: 'WAITTIME', label: '대기시간', sortable: true, width: 70, formatter: this.convertValue },
        { prop: 'TRANSACTION_BEGIN_TIME', label: '트랜잭션 시작 시간', sortable: true, searchable: true, searchType: 'date', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'LOGON_TIME', label: '접속 시작시간', sortable: true, searchable: true, searchType: 'date', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'CMD', label: '명령어', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      ],
    };
  },
  computed: {
    sessionColumns() {
      if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
        return this.columns;
      }
      const columns = cloneDeep(this.columns);
      columns.push({ label: 'SQL문', align: 'center', scopedSlot: 'sql-slot', width: 60 });
      return columns;
    },
  },
  methods: {
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.operationFlag ? (this.getDatetimeParams(new Date().getTime(), true)).startDatetime : this.plotLineDatetime,
        managetypeId: 'DBMS',
      };
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        params.queryId = 'DBMSSessionInfo';
        params.parameterMap = {
          orderby: 'LOGIN_TIME',
        };
        this.isLoading = true;
        databaseTableInfoAPI.getCurrentDbsessionList(params).then((result) => {
          if (result.data.success === true) {
            this.tableData = result.data.data;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      } else {
        this.isLoading = true;
        databaseTableInfoAPI.getDbsessionMssqlList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'DB 세션', false));
    },
    /**
     * [테이블 컬럼 포멧]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    convertValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
    /**
     * SQL문 상세 팝업을 연다.
     * @author Ju
     * @param  {[type]} row 세션 정보
     */
    showSqlDetailPopup(row) {
      this.$refs.sqlDetailPopup.open(row);
    },
    /**
     * [cputimeConvert 컬럼 convert]
     * @author {Yang}
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    cputimeConvert(row, column, value) {
      const msecPerSecond = 1000;
      const msecPerMinute = msecPerSecond * 60;
      const msecPerHour = msecPerMinute * 60;
      const msecPerDay = msecPerHour * 24;
      let remain;
      if (value < 1000) {
        remain = value / msecPerSecond;
      } else if ((value / msecPerMinute) < 1) {
        remain = `${floor(value / msecPerSecond)}초`;
      } else if ((value / msecPerHour) < 1) {
        const min = floor(value / msecPerMinute);
        const val = value - (min * msecPerMinute);
        const sec = floor(val / msecPerSecond);
        remain = `${min}분 ${sec}초`;
      } else if ((value / msecPerDay) < 1) {
        const hour = floor(value / msecPerHour);
        const val = value - (hour * msecPerHour);
        const min = floor(val / msecPerMinute);
        const val2 = val - (min * msecPerMinute);
        const sec = floor(val2 / msecPerSecond);
        remain = `${hour} 시간 ${min}분 ${sec}초`;
      } else if ((value / msecPerDay) < 1) {
        const day = floor(value / msecPerDay);
        const val = value - (day * msecPerDay);
        const hour = floor(val / msecPerHour);
        const val2 = val - (hour * msecPerHour);
        const min = floor(val2 / msecPerMinute);
        const val3 = val2 - (min * msecPerMinute);
        const sec = floor(val3 / msecPerSecond);
        remain = `{day}일 ${hour}시간 ${min}분 ${sec}초`;
      }
      return remain;
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onClickSetSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/DbSession/DbSessionMssqlTable.vue